import FormFieldType from '../types/FormFieldType';

export const eventTypes = {
  cmpReady: 'cmpReady',
};

export const storageKeys = {
  wishlist: 'wishlist',
  wishlistV2: 'wishlist_v2',
  wishlistLegacyBackup: 'wishlist_v2_legacy_backup',
  customerHash: 'survey_hash',
  surveysSeen: 'surveys_seen',
};

export const urlParams = {
  accessToken: 'productListAccessToken',
};

export const globalUserMessageDataKey = {
  globalUserMessage: 'globalUserMessage',
};

export const analytics = {
  checkout: {
    checkoutCartProductsListId: 'checkout_cart_products',
    checkoutCartProductsListName: 'Checkout Cart Products',
    checkoutRecommendedProductsListId: 'checkout_recommended_products',
    checkoutRecommendedProductsListName: 'Checkout Recommended Products',
  },
  wishlist: {
    wishlistProductListId: 'wishlist_products',
    wishlistProductListName: 'Wishlist Products',
  },
};

export const invalidFormFields = {
  checkout: new Set([FormFieldType.BOOLEAN, FormFieldType.BUTTON]),
};
